import Button from "../Button/Button";

type Props = {
  text: string | JSX.Element,
  isDisabled?: boolean,
  fn?: (a?: any) => void,
  actionName?: string
};

function PrimaryWithPropagate({text, fn = () => null, isDisabled = false, actionName = 'Primary Button'}: Props) {

  return (
    <Button 
      fn={fn} 
      text={text} 
      isDisabled={isDisabled} 
      cssStyles="text-white bg-darker-gold-200 hover:text-black hover:bg-darker-gold-100" 
      propagate={true}
      actionName={actionName}
    />
  );
}

export default PrimaryWithPropagate;
